module.exports = __webpack_public_path__ + "img/9788960171374.9c65e94a.jpg";